import axios from 'axios';
import { SignupMutations } from '@signing-page/api/signup/graphql/signup.mutations';
import { apolloClient } from '@signing-page/apollo';
import { ISignupResponse } from '@signing-page/signing/types/signup-response';

export class SignupService {
  private static readonly feedbackUrl: string =
    'https://api.hsforms.com/submissions/v3/integration/submit/541808/b3ab4496-af27-481f-9db0-1941231bf190';

  static async feedback(feedback: string, email: string): Promise<boolean> {
    const { data } = await axios.post(
      this.feedbackUrl,
      JSON.stringify({
        submittedAt: Date.now(),
        fields: [
          {
            name: 'email',
            value: email,
          },
          { name: 'improvement', value: feedback },
        ],
        context: {
          pageUri: '',
          pageName: '',
        },
      }),
      { headers: { 'Content-Type': 'application/json' } }
    );
    return data;
  }

  static async signup(
    email: string,
    sourceDetails = '',
    language?: string
  ): Promise<ISignupResponse> {
    const { data } = await apolloClient.mutate({
      mutation: SignupMutations.signupMutation,
      variables: {
        email,
        registrationSource: 'sign',
        sourceDetails,
        language: language,
      },
    });
    return data.signup;
  }
}
